//====================================================
//  Initialization Accordion
//====================================================
function fn_components_gallery(){
	if ($('.js-video-block').length){
		$('.js-video-block').lightGallery({
		    selector: 'this',
		    autoplay: true
		});
	}
	if ($('.js-gallery-block').length){
		$('.js-gallery-block').lightGallery({
		    selector: '.item'
		});
	}
}